import React, { useEffect, useState, useContext } from "react";
import { FormGroup, Col } from "reactstrap";
import {
  DatePicker,
  TextField,
  Radio,
  Button,
  MessageAlert,
  Dropdown,
} from "../../../components/Components";
import { formDataContext } from "../BillingSummaryReport";
import "./Search.css";
import { useTranslation } from "react-i18next";
import { MdSearch } from "react-icons/md";
import {
  ConvertInputDateToISOFormatDateTimeString,
  ConvertFormatDateTimetoDate,
} from "../../../utils/DateUtil";

const Search = () => {
  const {
    billingTypeList,
    billingStatusList,
    setListHistoryBillingRq,
    setIsClickSearch,
    setPage,
    isFetch,
    setIsFetch,
  } = useContext(formDataContext);
  const [billingType, setBillingType] = useState(null);
  const [billingStatus, setBillingStatus] = useState(null);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const { t } = useTranslation();

  const fetchData = async () => {
    const now = new Date();
    const oneMonth = new Date();
    oneMonth.setMonth(now.getMonth() - 1);
    setDateFrom(oneMonth);
    setDateTo(now);
    setListHistoryBillingRq((prev) => ({
      ...prev,
      lotno: null,
      advno: null,
      deliveryStart: ConvertInputDateToISOFormatDateTimeString(oneMonth),
      deliveryEnd: ConvertInputDateToISOFormatDateTimeString(now),
    }));
    setBillingStatus(null);
    setBillingType(null);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (isFetch) {
      fetchData();
      setIsFetch(false);
    }
  }, [isFetch]);

  return (
    <>
      <div className="ShearchContainer">
        <div className="ShearchDetailComponent">
          <span className="textHeader">{t("SummaryReportBilling")}</span>
        </div>

        <div className="ShearchDetailComponent">
          <div>
            <FormGroup row>
              <Col xs={12}>
                <div>
                  <div>
                    <FormGroup row>
                      <Col xs={1} className="textTitle">
                        <span>{t("BillingType")}</span>
                      </Col>
                      <Col xs={2}>
                        <Dropdown
                          style={{ fontSize: "14px" }}
                          placeholder={t("All")}
                          options={billingTypeList?.map((item) => ({
                            label: `${item?.configDesc}`,
                            value: item?.configValue,
                          }))}
                          isClearable={true}
                          value={billingType}
                          onChange={(e) => {
                            setBillingType(e);
                            setListHistoryBillingRq((prev) => ({
                              ...prev,
                              billingType: e?.value ?? null,
                            }));
                          }}
                        />
                      </Col>

                      <Col xs={2} className="textTitle">
                        <span >{t("BillingStatus")}</span>
                      </Col>
                      <Col xs={2}>
                        <Dropdown
                          style={{ fontSize: "14px" }}
                          placeholder={t("All")}
                          options={billingStatusList?.map((item) => ({
                            label: `${item?.configDesc}`,
                            value: item?.configValue,
                          }))}
                          isClearable={true}
                          value={billingStatus}
                          onChange={(e) => {
                            setBillingStatus(e);
                            setListHistoryBillingRq((prev) => ({
                              ...prev,
                              billingStatus: e?.value ?? null,
                            }));
                          }}
                        />
                      </Col>

                      <Col xs={2} className="textTitle">
                        <span>{t("LotNo")}</span>
                      </Col>
                      <Col xs={3}>
                        <TextField
                          style={{ fontSize: "14px" }}
                          placeholder={`${t("PleaseSpecify")} ${t("LotNo")}`}
                          onChange={(e) => {
                            const value =
                              e.target.value == null ||
                              e.target.value.trim() == ""
                                ? null
                                : e.target.value.toUpperCase().trim();
                            setListHistoryBillingRq((prev) => ({
                              ...prev,
                              lotno: value,
                            }));
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </div>
                  <div>
                    <FormGroup row>
                      <Col xs={1} className="textTitle">
                        <span
                          style={{
                            fontSize: "14px",
                            color: "red",
                          }}
                        >
                          {"*"}
                        </span>
                        <span>{t("DeliveryDate")}</span>
                      </Col>
                      <Col xs={3} style={{ position: "relative" }}>
                        <DatePicker
                          selected={dateFrom}
                          placeholderText={t("PleaseSpecifyDate")}
                          style={{
                            backgroundSize: "25px",
                            height: "38px",
                            fontSize: "15px",
                          }}
                          dateFormat="dd/MM/yyyy"
                          name="reqDateFrom"
                          minDate={new Date(dateTo)?.setMonth(
                            dateTo?.getMonth() - 1
                          )}
                          maxDate={dateTo}
                          onChange={(date) => {
                            setDateFrom(date);
                            setListHistoryBillingRq((prev) => ({
                              ...prev,
                              deliveryStart:
                                date == null
                                  ? null
                                  : ConvertInputDateToISOFormatDateTimeString(
                                      date
                                    ),
                            }));
                          }}
                        />

                        <span
                          style={{
                            fontSize: "14px",
                            color: "red",
                            position: "absolute",
                            top: "40px",
                            left: "20px",
                          }}
                        >
                          {`( ${t("SpecifyDeliveryDateNoMoreThan31Days")} )`}
                        </span>
                        <span
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "-3px",
                          }}
                        >
                          {"-"}
                        </span>
                      </Col>
                      <Col xs={3}>
                        <DatePicker
                          selected={dateTo}
                          placeholderText={t("PleaseSpecifyDate")}
                          style={{
                            backgroundSize: "25px",
                            height: "38px",
                            fontSize: "15px",
                          }}
                          dateFormat="dd/MM/yyyy"
                          name="reqDateTo"
                          minDate={dateFrom}
                          maxDate={new Date(dateFrom)?.setMonth(
                            dateFrom?.getMonth() + 1
                          )}
                          onChange={(date) => {
                            setDateTo(date);
                            setListHistoryBillingRq((prev) => ({
                              ...prev,
                              deliveryEnd:
                                date == null
                                  ? null
                                  : ConvertInputDateToISOFormatDateTimeString(
                                      date
                                    ),
                            }));
                          }}
                        />
                      </Col>
                      <Col xs={2} className="textTitle">
                        <span>{t("AdvNo")}</span>
                      </Col>
                      <Col xs={3}>
                        <TextField
                          style={{ fontSize: "14px" }}
                          placeholder={`${t("PleaseSpecify")} ${t("AdvNo")}`}
                          onChange={(e) => {
                            const value =
                              e.target.value == null ||
                              e.target.value.trim() == ""
                                ? null
                                : e.target.value.toUpperCase().trim();
                            setListHistoryBillingRq((prev) => ({
                              ...prev,
                              advno: value,
                            }));
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </div>
                </div>
              </Col>
            </FormGroup>
          </div>

          <div className="rightItem">
            <Button
              style={{ width: "120px", position: "relative" }}
              title={t("Search")}
              icon={
                <MdSearch
                  style={{
                    position: "absolute",
                    top: "6px",
                    right: "10px",
                    height: "25px",
                    width: "25px",
                  }}
                />
              }
              onClick={() => {
                setPage(1);
                setIsClickSearch(true);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Search;
